module.exports = __webpack_public_path__ + "static/media/xiaoniu_1.jpg";